import { AlertColor } from "@mui/material";
import { createContext } from "react";

interface SnackbarInterface {
  openSnackbar: (message: string, severity: AlertColor) => void;
}

export default createContext<SnackbarInterface | null>(null);
